/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./indexGuide.vue?vue&type=template&id=983b8782&scoped=true"
import script from "./indexGuide.vue?vue&type=script&lang=js"
export * from "./indexGuide.vue?vue&type=script&lang=js"
import style0 from "./indexGuide.vue?vue&type=style&index=0&id=983b8782&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983b8782",
  null
  
)

export default component.exports